import { render, staticRenderFns } from "./TenderEditComponent.vue?vue&type=template&id=4540f446"
import script from "./TenderEditComponent.vue?vue&type=script&lang=js"
export * from "./TenderEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports